module.exports = __webpack_public_path__ + "static/media/boneIcon-02.9bc86954.png";